<template>
  <v-layout style="padding-bottom: 5px;">
    <v-flex style="vertical-align: middle" class="text-truncate">{{ stock[1] }}</v-flex>

    <v-flex shrink class="text-xs-right" style="white-space: nowrap;">
      <div style="display: inline-block;">
        <v-btn
          small
          fab
          color="primary"
          outline
          class="extra-small ma-0"
          v-if="
            !(
              selectedBot.useketshop == true &&
              selectedBot.ketshop_api_key &&
              selectedBot.ketshop_api_secret
            )
          "
          @click="removeCount()"
          :disabled="stock[2] == this.min || addloading"
        >
          <span class="fa fa-minus"></span>
        </v-btn>

        <span
          style="width: 30px;display:inline-block;margin-left:5px;margin-right:5px;text-align:center"
          >{{ stock[2] }}</span
        >
        <v-btn
          small
          fab
          color="primary"
          outline
          class="extra-small ma-0"
          v-if="
            !(
              selectedBot.useketshop == true &&
              selectedBot.ketshop_api_key &&
              selectedBot.ketshop_api_secret
            )
          "
          @click="addCount()"
          :disabled="stock[2] == this.max - 1 || deleteloading"
        >
          <span class="fa fa-plus"></span>
        </v-btn>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: ['value', 'productId'],
  data: function() {
    return {
      stock: this.value,
      max: 10000,
      min: 0,
      addloading: false,
      deleteloading: false
    }
  },
  watch: {
    value: function() {
      this.stock = this.value
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    removeCount: function() {
      if (this.stock[2] > this.min) {
        this.stock[2] = parseInt(this.stock[2]) - 1
        let stock = [
          this.stock[0],
          this.stock[1],
          this.stock[2],
          this.stock[3],
          this.stock[4],
          this.stock[5],
          this.stock[6]
        ]
        this.updateStock('productstockdelete')
        this.$emit('input', stock)
      }
    },
    addCount: function() {
      if (this.stock[2] < this.max) {
        this.stock[2] = parseInt(this.stock[2]) + 1
        let stock = [
          this.stock[0],
          this.stock[1],
          this.stock[2],
          this.stock[3],
          this.stock[4],
          this.stock[5],
          this.stock[6]
        ]
        this.updateStock('productstockadd')
        this.$emit('input', stock)
      }
    },
    updateStock: function(operation) {
      let vm = this
      // let productstock = {
      //   id: vm.stock[0],
      //   option: vm.stock[1],
      //   productid: this.productId,
      //   quantity: vm.stock[2],
      //   price: vm.stock[3],
      //   discountprice: vm.stock[4]
      // }
      // api.editProductStock(productstock, function(error, response) {
      //   if (error) {
      //     console.error(error)
      //   }
      // })

      var data = { productstockid: this.stock[0], quantity: 1 }
      if (operation == 'productstockadd') {
        // vm.addloading = true
        api.productstockadd(data, (error, response) => {
          // vm.addloading = false
        })
      } else {
        // vm.deleteloading = true
        api.productstockdelete(data, (error, response) => {
          // vm.deleteloading = false
        })
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/StockItem.vue